import { create } from 'zustand';
import { devtools } from 'zustand/middleware';
import { immer } from 'zustand/middleware/immer';

interface NavHistoryStore {
    prevRoute: string | null;
    setPrevRoute: (val: string) => void;
}

export const useNavHistory = create<NavHistoryStore>()(
    devtools(
        immer((set, _) => ({
            prevRoute: null,
            setPrevRoute: (val: string) => set({
                prevRoute: val
            })
        }))
    ),
);
